import { render, staticRenderFns } from "./ResultTotals.vue?vue&type=template&id=060982f8&"
import script from "./ResultTotals.vue?vue&type=script&lang=ts&"
export * from "./ResultTotals.vue?vue&type=script&lang=ts&"
import style0 from "./ResultTotals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060982f8')) {
      api.createRecord('060982f8', component.options)
    } else {
      api.reload('060982f8', component.options)
    }
    module.hot.accept("./ResultTotals.vue?vue&type=template&id=060982f8&", function () {
      api.rerender('060982f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/results/ResultTotals.vue"
export default component.exports